var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-color"},[_c('div',{staticClass:"background-color iframe-div"},[_c('NavBarVue'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"src":"/privacy.html","width":"100%","height":"80%","frameborder":"0"}})])
}]

export { render, staticRenderFns }